import IItem from 'types/product_delivery';

export const PRICE_COL = {
    id: 'מזהה',
    externalId: 'מזהה חיצוני',
    barcode: 'ברקוד',
    name: 'שם מוצר',
    price: 'מחיר',
    discount: 'הנחה',
} as const;

export function normBarcode(s: string): string {
    if (!s) return '';
    const t = s.replace(/\u0000/g, '').replace(/['"]/g, '').trim();
    if (t === '') return '';
    const n = parseFloat(t.replace(/,/g, '.'));
    if (!Number.isNaN(n)) return String(Math.trunc(n));
    return t;
}

export function findPriceRow(
    products: IItem[],
    idNum: number | undefined,
    ext: string | undefined,
    code: string | undefined,
): IItem | undefined {
    if (idNum != null && !Number.isNaN(idNum) && idNum > 0) {
        const p = products.find((x) => Number(x.id) === idNum);
        if (p) return p;
    }
    if (ext != null && String(ext).trim() !== '') {
        const e = String(ext).trim();
        const p = products.find((x) => String(x.external_id ?? '').trim() === e);
        if (p) return p;
    }
    if (code != null && String(code).trim() !== '') {
        const b = normBarcode(String(code));
        if (b)
            return products.find(
                (x) => normBarcode(String(x.barcode ?? '')) === b || String(x.barcode ?? '').trim() === String(code).trim(),
            );
    }
    return undefined;
}

